if (!customElements.get('swaggy-garment-gallery')) {
  customElements.define('swaggy-garment-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      this.addEventListener('click', event => {
        const link = event.target.closest('a[data-garment-image]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.opener = link;
        const image = dialog.querySelector('[data-garment-full-image]');
        image.src = link.querySelector('img').currentSrc || link.href;
        image.alt = link.querySelector('img').alt;
        dialog.querySelector('[data-garment-dialog-title]').textContent = link.dataset.label;
        dialog.showModal();
        dialog.querySelector('[data-garment-close]').focus();
        const fullImage = new Image();
        fullImage.onload = () => { if (dialog.open && this.opener === link) image.src = fullImage.src; };
        fullImage.src = link.href;
      }, options);
      dialog.querySelector('[data-garment-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
